import { jsxs as i, Fragment as $, jsx as e } from "react/jsx-runtime";
import H from "../Amenities/Amenities.js";
import K from "../AvailableNow/AvailableNow.js";
import Q from "../FloorPlanIcon/FloorPlanIcon.js";
import J from "../GreatSchools/GreatSchools.js";
import X from "../LeadForm/LeadForm.js";
import { validationSchemaIsLogged as Y, validationSchema as Z } from "../LeadModal/validations.js";
import ee from "../LetsGoTouringModal/LetsGoTouringModal.js";
import te from "../PromotionsSection/PromotionSection.js";
import oe from "../ScheduleShowingButton/ScheduleShowingButton.js";
import { SeeMore as re } from "../SeeMore/SeeMore.js";
import ie from "../UnitDetailMap/UnitDetailsMap.js";
import ne from "../UnitHeader/UnitHeader.js";
import r from "@material-ui/core/Box";
import B from "@material-ui/core/Button";
import ae from "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import le from "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import u from "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import me from "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/makeStyles";
import se from "@material-ui/core/styles/useTheme";
import de from "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import s from "@material-ui/core/Typography";
import ce from "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import pe from "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import he from "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import fe from "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import ue from "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { useSessionContext as be, getBathroomCount as ge, getAddressDescription as ye, getAddressCityStateAndPostal as Se, IconIndicator as p, CONTACT_PHONE as P, normalizePhoneNumber as Ce } from "@propify-tenant-client/common";
import { getSdkUnitDetailsClassNames as b, getSdkUnitDetailsClassName as l } from "../../utils/sdk.js";
import { getApplyNowLink as ve, getPetPolicyText as Ne } from "../../utils/utils.js";
import { isSDK as h, SHORT_DATE_FORMAT as Ae, LeadService as we, LeadStatus as De, handleError as Te } from "@propify-tenant-client/services";
import { formatCurrency as xe } from "@propify/components";
import M from "big.js";
import n from "classnames";
import { Formik as Ie } from "formik";
import ke from "lodash/isEmpty";
import Le from "lodash/unionBy";
import z from "moment";
import { useState as g } from "react";
const f = "#2C5982", Be = (t) => me({
  container: {
    width: "100%",
    position: "relative"
  },
  innerContainer: {
    [`${t.breakpoints.down("md")}`]: {
      overflow: "hidden"
    }
  },
  galleryContainer: {
    height: 500,
    background: "lightgrey",
    position: "relative",
    [`${t.breakpoints.down("sm")}`]: {
      height: 350
    }
  },
  actionsContainer: {
    display: "flex",
    gap: 18,
    alignItems: "center"
  },
  formContainer: {
    position: "sticky",
    top: 8
  },
  formCard: {
    borderRadius: 8
  },
  contactUs: {
    textAlign: "center",
    fontSize: 15,
    fontWeight: 600
  },
  button: {
    padding: "10px 18px",
    borderRadius: 50,
    textTransform: "none",
    background: "#0C57A5",
    whiteSpace: "nowrap",
    "&:hover": {
      background: "#0C57A5"
    }
  },
  buttonSuccess: {
    background: "#55BA00",
    "&:hover": {
      background: "#55BA00"
    }
  },
  leadDisclaimer: {
    fontSize: 12,
    color: "#363636"
  },
  unitTitle: {
    fontSize: 30,
    fontWeight: 700,
    color: f
  },
  unitSubTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: f
  },
  unitTitleSecondary: {
    fontSize: 14,
    marginTop: 4
  },
  specsPriceContainer: {
    display: "flex",
    alignItems: "center",
    [t.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 8
    }
  },
  specsContainer: {
    color: f,
    display: "flex",
    alignItems: "center",
    gap: 16,
    flex: 1,
    "& span": {
      fontSize: 12,
      fontWeight: 700
    },
    [t.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "space-between"
    }
  },
  price: {
    color: f,
    fontSize: 24,
    fontWeight: 700,
    position: "relative",
    "&::before": {
      content: '"*"',
      display: "block",
      position: "absolute",
      top: -10,
      right: -10
    }
  },
  overviewContent: {
    whiteSpace: "pre-line",
    color: "#41444B",
    fontSize: 16
  },
  mapWrapper: {
    height: 470,
    position: "relative",
    [t.breakpoints.down("sm")]: {
      marginLeft: -40,
      marginRight: -40
    }
  },
  mobileActionsContainer: {
    position: "sticky",
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 18,
    background: "rgba(255, 255, 255, .95)",
    zIndex: 10
  }
}), Pe = ({ unit: t, classes: o, onLoginSubmit: R, onRegisterSubmit: W }) => {
  var w, D, T, x, I, k;
  const U = se(), c = ce(U.breakpoints.down("md")), [E, y] = g(!1), [O, S] = g(!1), [q, C] = g(!1), { login: a } = be(), F = (m, L) => {
    y(!1), S(!0), we.create({
      source: h() ? "website" : "publicClient",
      status: De.ACTIVE,
      firstName: m.firstName || (a == null ? void 0 : a.firstName) || void 0,
      lastName: m.lastName || (a == null ? void 0 : a.lastName) || void 0,
      phone: Ce(m.phone) || (a == null ? void 0 : a.phone) || void 0,
      email: m.email || (a == null ? void 0 : a.email) || void 0,
      message: m.message || void 0,
      propertyId: t.property.id,
      floorplanId: t.floorplanId,
      unitId: t.id
    }).then(() => {
      L.resetForm(), L.setSubmitting(!1), y(!0), S(!1);
    }).catch((_) => {
      Te(_, { toastMessage: "An error occurred, please try again" });
    });
  };
  if (!t || !t.property)
    return null;
  const v = !ke(a), d = {
    latitude: (w = t.property.address.location) == null ? void 0 : w.latitude,
    longitude: (D = t.property.address.location) == null ? void 0 : D.longitude
  }, G = Le(t.amenities, "typeId"), V = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  }, j = { message: "" }, N = ge(t), A = /* @__PURE__ */ i($, { children: [
    t.listingStatus === "ACTIVE" && /* @__PURE__ */ i("div", { children: [
      /* @__PURE__ */ e(
        oe,
        {
          unit: t,
          className: n(
            o.button,
            b(["button", "showing-button"])
          ),
          size: "medium",
          variant: "contained",
          onLetsGoTouringModalOpen: () => {
            C(!0);
          }
        }
      ),
      /* @__PURE__ */ e(
        ee,
        {
          open: q,
          onClose: () => C(!1),
          unit: t,
          onLoginSubmit: R,
          onRegisterSubmit: W
        }
      )
    ] }),
    /* @__PURE__ */ e(
      B,
      {
        variant: "contained",
        color: "primary",
        className: n(
          o.button,
          o.buttonSuccess,
          b(["button", "apply-button"])
        ),
        size: "medium",
        startIcon: /* @__PURE__ */ e(he, {}),
        href: ve(t) ?? "",
        target: h() ? "_blank" : void 0,
        rel: h() ? "noopener noreferrer" : void 0,
        children: "Apply Now"
      }
    )
  ] });
  return /* @__PURE__ */ i("div", { className: n(o.container, l("container")), children: [
    /* @__PURE__ */ e(
      r,
      {
        mb: 3,
        className: n(
          o.galleryContainer,
          l("gallery-container")
        ),
        children: /* @__PURE__ */ e(ne, { unit: t })
      }
    ),
    /* @__PURE__ */ e(le, { maxWidth: "xl", className: o.innerContainer, children: /* @__PURE__ */ e(r, { px: 2, children: /* @__PURE__ */ i(u, { container: !0, spacing: 8, children: [
      /* @__PURE__ */ i(u, { item: !0, md: 12, lg: 8, children: [
        /* @__PURE__ */ e(
          K,
          {
            label: z(t.readyDate).isAfter() ? `Available: ${z(t.readyDate).format(Ae)}` : void 0
          }
        ),
        /* @__PURE__ */ e(r, { mt: 2, mb: 1, children: /* @__PURE__ */ e(
          s,
          {
            className: n(o.unitTitle, l("title")),
            children: ye((T = t == null ? void 0 : t.property) == null ? void 0 : T.address, !0)
          }
        ) }),
        /* @__PURE__ */ e(
          s,
          {
            className: n(o.unitSubTitle, l("subtitle")),
            children: Se((x = t == null ? void 0 : t.property) == null ? void 0 : x.address)
          }
        ),
        /* @__PURE__ */ i(
          r,
          {
            className: o.specsPriceContainer,
            borderTop: "1px solid #DADADA",
            borderBottom: "1px solid #DADADA",
            py: 2,
            my: 2,
            children: [
              /* @__PURE__ */ i(
                "div",
                {
                  className: n(
                    o.specsContainer,
                    l("specs-container")
                  ),
                  children: [
                    /* @__PURE__ */ e(
                      p,
                      {
                        icon: /* @__PURE__ */ e(fe, {}),
                        value: /* @__PURE__ */ i("span", { children: [
                          t.bedroomCount,
                          " ",
                          t.bedroomCount === 1 ? "Bed" : "Beds"
                        ] })
                      }
                    ),
                    /* @__PURE__ */ e(
                      p,
                      {
                        icon: /* @__PURE__ */ e(pe, {}),
                        value: /* @__PURE__ */ i("span", { children: [
                          N,
                          " ",
                          N === 1 ? "Bath" : "Baths"
                        ] })
                      }
                    ),
                    /* @__PURE__ */ e(
                      p,
                      {
                        icon: /* @__PURE__ */ e(Q, {}),
                        value: /* @__PURE__ */ i("span", { children: [
                          t.squareFeet,
                          " sq ft"
                        ] })
                      }
                    ),
                    /* @__PURE__ */ e(
                      p,
                      {
                        icon: /* @__PURE__ */ e(ue, {}),
                        value: /* @__PURE__ */ i("span", { children: [
                          Ne(t.property.petPolicy, c),
                          " ",
                          !c && "Allowed"
                        ] })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ e("span", { className: o.price, children: t.listedRent ? `${xe(M(t.listedRent).round(0, M.roundUp), {
                noEmptyDecimals: !0
              })}/mo` : "" })
            ]
          }
        ),
        ((I = t.featuredPromotions) == null ? void 0 : I.length) && /* @__PURE__ */ e(r, { my: 2, children: /* @__PURE__ */ e(te, { featuredPromotions: t.featuredPromotions }) }),
        /* @__PURE__ */ e(
          s,
          {
            variant: "h6",
            className: n(o.unitSubTitle, l("subtitle")),
            children: "Overview"
          }
        ),
        /* @__PURE__ */ e(r, { mt: 2, children: /* @__PURE__ */ e(
          re,
          {
            minLength: 350,
            idealLength: 400,
            maxLength: 600,
            typographyProps: { className: o.overviewContent },
            children: t.marketingDescription || "No overview"
          }
        ) }),
        /* @__PURE__ */ e(r, { borderTop: "1px solid #DADADA", pb: 2, pt: 3, mt: 4, children: /* @__PURE__ */ e(H, { list: G }) }),
        d.latitude && d.longitude ? /* @__PURE__ */ i(r, { borderTop: "1px solid #DADADA", mt: 2, pb: 4, pt: 3, children: [
          /* @__PURE__ */ e(r, { mb: 2, children: /* @__PURE__ */ e(
            s,
            {
              className: n(
                o.unitSubTitle,
                l("subtitle")
              ),
              children: "Map"
            }
          ) }),
          /* @__PURE__ */ e("div", { className: o.mapWrapper, children: /* @__PURE__ */ e(ie, { point: d }) })
        ] }) : null,
        (k = t.nearbySchools) != null && k.length ? /* @__PURE__ */ i(
          r,
          {
            pt: 3,
            pb: 2,
            borderTop: "1px solid #DADADA",
            mt: d.latitude && d.longitude ? 6 : 2,
            children: [
              /* @__PURE__ */ i(r, { mb: 2, children: [
                /* @__PURE__ */ e(
                  s,
                  {
                    className: n(
                      o.unitSubTitle,
                      l("subtitle")
                    ),
                    children: "Nearby Schools"
                  }
                ),
                /* @__PURE__ */ e(s, { className: o.unitTitleSecondary, children: "GreatSchools Ratings" })
              ] }),
              /* @__PURE__ */ e(J, { schools: t.nearbySchools })
            ]
          }
        ) : null,
        /* @__PURE__ */ e("span", { children: "DISCLAIMER: Rent shown is the average monthly rent for a new resident over the lowest price lease term, based on selected move-in date and applying all applicable specials. Minimum lease terms and occupancy guidelines may apply. Actual monthly rent payments may vary and will be as described in the lease contract. Additional fees and charges may apply and will be disclosed as per community requirements, governing laws and company policies. Rent, availability, and specials are subject to change without notice. Amount of required deposits will be based on credit, rental history, income, and/or other qualifying standards." })
      ] }),
      !c && /* @__PURE__ */ i(u, { item: !0, md: 5, lg: 4, children: [
        /* @__PURE__ */ e(r, { mb: 3, className: o.actionsContainer, children: A }),
        /* @__PURE__ */ e(
          r,
          {
            className: n(
              o.formContainer,
              l("contact-us-container")
            ),
            children: /* @__PURE__ */ e(
              ae,
              {
                elevation: 5,
                className: o.formCard,
                style: { top: h() ? 8 : 64 },
                children: /* @__PURE__ */ e(r, { p: 2, children: /* @__PURE__ */ e(
                  Ie,
                  {
                    initialValues: v ? j : V,
                    onSubmit: F,
                    validationSchema: v ? Y : Z,
                    children: (m) => /* @__PURE__ */ i("form", { onSubmit: m.handleSubmit, children: [
                      /* @__PURE__ */ e(r, { mb: 1, children: /* @__PURE__ */ e(
                        s,
                        {
                          className: l("contact-us-title"),
                          variant: "h6",
                          children: "Contact us today"
                        }
                      ) }),
                      /* @__PURE__ */ e(
                        X,
                        {
                          formProps: m,
                          noMargin: !0,
                          success: E,
                          login: a
                        }
                      ),
                      /* @__PURE__ */ e(
                        r,
                        {
                          my: 2,
                          mb: 3,
                          className: n(
                            o.leadDisclaimer,
                            l("contact-us-disclaimer")
                          ),
                          children: "By registering, you agree to Terms of Use and Privacy Policy and consent to be contacted at this phone number by text message, and/or by autodialer for any purpose, including marketing, by the property and anyone acting on their behalf. Consent not required to purchase or rent."
                        }
                      ),
                      /* @__PURE__ */ e(
                        B,
                        {
                          fullWidth: !0,
                          variant: "contained",
                          color: "primary",
                          type: "submit",
                          disabled: !m.isValid || O,
                          className: n(
                            o.button,
                            b(["button", "contact-button"])
                          ),
                          children: "Submit"
                        }
                      ),
                      /* @__PURE__ */ e(r, { mt: 2, pb: 1, children: /* @__PURE__ */ i(
                        s,
                        {
                          className: n(
                            o.contactUs,
                            l("contact-us-info")
                          ),
                          children: [
                            "Call us at",
                            " ",
                            /* @__PURE__ */ e("a", { href: `tel:${P.replace(/\D/g, "")}`, children: P }),
                            " ",
                            "to talk with one of our professional leasing agents."
                          ]
                        }
                      ) })
                    ] })
                  }
                ) })
              }
            )
          }
        )
      ] })
    ] }) }) }),
    c && /* @__PURE__ */ e(
      r,
      {
        py: 3,
        px: 2,
        className: n(
          o.mobileActionsContainer,
          l("mobile-actions-container")
        ),
        children: A
      }
    )
  ] });
}, Yt = de(Be, { name: "UnitDetails" })(Pe);
export {
  Yt as default
};
//# sourceMappingURL=UnitDetails.js.map
